module.exports = __webpack_public_path__ + "img/freebsd.19ae3735.svg";